import React from 'react';
import { SalesOrderPreviewTemplate } from 'themes/application/patient/pages';
import { observer } from 'mobx-react';
import { SalesOrderPreviewViewStore } from 'application/patient/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new SalesOrderPreviewViewStore(rootStore), 'salesOrderPreviewViewStore')
@observer
class SalesOrderPreview extends React.Component {
    render() {
        return <SalesOrderPreviewTemplate {...this.props} />
    }
}

export default SalesOrderPreview;